import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//FLN get api as activity type
export const getAmazonPayThunk = createAsyncThunk(
  "amazon/get",
  async (data) => {
    let response = await api.get(`getAllRewardCoupons`);
    return response.data;
  }
);
export const getAmazonPayPasswordThunk = createAsyncThunk(
  "amazon/get",
  async (data) => {
    let response = await api.get(
      `checkCouponsCred/admin.coupons@tz.in/tHINKZONEcda-11`
    );
    return response.data;
  }
);
export const getDeletedListThunk = createAsyncThunk(
  "amazon/getDeletedList",
  async (data) => {
    let response = await api.get(`getTempDeletedCoupons`);
    return response.data;
  }
);

export const createAmazonPayThunk = createAsyncThunk(
  "amazon/create",
  async (body) => {
    const response = await api.post("saveRewardCoupons", body);
    return {
      status: response.status,
      data: response.data,
    };
  }
);

export const updateAmazonPayThunk = createAsyncThunk(
  "amazon/update",
  async (reqbody) => {
    const id = reqbody.skillId;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.patch("updateRewardCoupons", body);
    return response.data;
  }
);

export const restoreAmazonPayThunk = createAsyncThunk(
  "amazon/update",
  async (body) => {
    let response = await api.patch("restoreRewardCoupons", body);
    return response.data;
  }
);

// export const tempDeleteAmazonPayThunk = createAsyncThunk(
//   "amazon/tempdelete",
//   async (body) => {
//     console.log("tempDeleteAmazonPayThunk", body);
//     let response = await api.delete("tempDeleteRewardCoupons", { body });
//     return response.data;
//   }
// );

export const tempDeleteAmazonPayThunk = createAsyncThunk(
  "temorary/delete",
  async (data) => {
    const response = await api.delete(`tempDeleteRewardCoupons`, { data });
    return response.data;
  }
);

export const deleteAmazonPayThunk = createAsyncThunk(
  "amazon/delete",
  async (couponId) => {
    console.log("couponId-->", couponId);
    let response = await api.delete("deleteRewardCoupons/" + couponId);
    return response.data;
  }
);
